export default "__VITE_PUBLIC_ASSET__bcd5974d__"